// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep ol,
:host ::ng-deep ul,
::ng-deep ol,
::ng-deep ul {
  padding-left: 0px !important;
  margin-left: 0 !important;
}
ol, ul {
  padding-left: 0px !important;
  margin-left: 0 !important;
}
/* ========== Container & Layout ========== */
.dynamic-table-container {
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: visible;
  position: relative;
}

.dynamic-table {
   margin: 10px !important;
}

.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.5rem 0;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  position: relative;
}

/* Remove gap from button container */
.d-flex.align-items-center.mb-1 {
  gap: 0 !important;
}

.global-search {
  position: relative;
  display: flex;
  align-items: center;
}

.global-search .pi-search {
  position: absolute;
  left: 10px;
  top: 60%;
  transform: translateY(-60%);
  z-index: 1;
  pointer-events: none;
}

.global-search .search-input {
  padding-left: 35px;
  padding-right: 30px;
  min-width: 200px;
}

.global-search .clear-search {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  z-index: 2;
}

.global-search .clear-search:hover {
  color: #333;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  margin: 15px 0;
  margin-bottom: 60px;
  position: relative;
}

.exportExcelBtn {
  margin-left: 0;
}

/* Column Settings Button */
.column-settings-button {
  margin-left: 0;
}

/* Column Settings Panel */
.column-settings-panel {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 0.5rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 400px;
  max-width: 500px;
}

.column-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.column-settings-header h5 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.column-settings-header .close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  font-size: 1.2rem;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  transition: background-color 0.2s, color 0.2s;
}

.column-settings-header .close-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.column-settings-body {
  padding: 1rem;
  max-height: 400px;
  overflow-y: auto;
}

.settings-table {
  width: 100%;
  border-collapse: collapse;
}

.settings-table thead tr {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.settings-table th {
  padding: 0.75rem 0.5rem;
  text-align: left;
  font-weight: 600;
  color: #495057;
  font-size: 0.95rem;
}

.settings-table tbody tr {
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s;
}

.settings-table tbody tr:hover {
  background-color: #f8f9fa;
}

.settings-table tbody tr:last-child {
  border-bottom: none;
}

.settings-table td {
  padding: 0.75rem 0.5rem;
  color: #333;
}

.settings-table .checkbox-cell {
  text-align: center;
  width: 100px;
}

.settings-table .disabled-text {
  color: #6c757d;
  font-style: italic;
  font-size: 0.9rem;
}

/* Ensure pagination stays at bottom and center-aligned */
::ng-deep .p-datatable .p-paginator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  overflow: visible !important;
}

/* Make pagination dropdown smaller */
::ng-deep .p-paginator .p-paginator-rpp-options {
  width: auto !important;
  min-width: 45px !important;
  max-width: 55px !important;
  height: 28px !important;
  font-size: 0.875rem !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
}

::ng-deep .p-paginator .p-dropdown {
  height: 28px !important;
  min-height: 28px !important;
  margin-left: 0 !important;
  width: 55px !important;
}

::ng-deep .p-paginator .p-dropdown .p-dropdown-trigger {
  width: 1.5rem !important;
}

::ng-deep .p-paginator .p-dropdown .p-dropdown-label {
  padding: 0.25rem 0.25rem !important;
  padding-left: 0.25rem !important;
  font-size: 0.875rem !important;
}

/* Ensure pagination dropdown panel is fully visible */
::ng-deep .p-paginator .p-dropdown-panel {
  z-index: 1100 !important;
  margin-top: 2px !important;
}

::ng-deep .p-paginator .p-dropdown-panel .p-dropdown-items {
  padding: 0 !important;
}

::ng-deep .p-paginator .p-dropdown-panel .p-dropdown-item {
  padding: 0.5rem 0.75rem !important;
  margin: 0 !important;
}

::ng-deep .p-paginator .p-dropdown-panel .p-dropdown-items-wrapper {
  padding: 0 !important;
}

::ng-deep .p-datatable-wrapper {
  overflow-x: visible;
  overflow-y: visible;
}

/* PrimeNG button disabled state */
::ng-deep .p-button.p-disabled,
::ng-deep .p-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Filter dropdown styles */
.sfcDropDown {
  margin-left: 0;
}

::ng-deep .sfcDropDown .p-multiselect {
  border: none;
  background: transparent;
}

::ng-deep .sfcDropDown .p-multiselect-trigger {
  color: #007bff;
}

::ng-deep .filter-control .p-multiselect {
  min-height: auto;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #dee2e6;
}

.filterLbl {
  padding-left: 10px !important;
}

.filter-header .okBtn,
.filter-header .clearBtn {
  padding: 0 8px;
  font-size: 14px;
  text-decoration: none !important;
  color: #007bff;
  background: none;
  border: none;
  cursor: pointer;
}

.filter-header .okBtn:hover,
.filter-header .clearBtn:hover {
  text-decoration: underline !important;
}

/* Table styles */
::ng-deep .p-datatable .p-datatable-thead > tr > th {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 0.5rem 0.4rem;
  font-weight: 600;
  text-align: left;
  vertical-align: middle;
}
/*
::ng-deep .p-datatable .p-datatable-tbody > tr > td.audit-updated-cell {
  background-color: #fff59d !important;
}
*/
/* Header Content Wrapper - Inline alignment */
.header-content-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  min-width: 0;
}

.header-text {
  flex: 1 1 0;
  font-weight: 600;
  margin-right: 0.15rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-sort-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin-left: 0.15rem;
  z-index: 1;
}

.header-filter-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin-left: 0.15rem;
  z-index: 1;
}

.title{
  margin-bottom: 0;
  margin-left: -15px;
}

::ng-deep .header-sort-icon .p-sortable-column-icon {
  font-size: 1rem;
}

/* Sort and Filter Row Styling - DEPRECATED (keeping for backward compatibility) */
::ng-deep .p-datatable .p-datatable-thead > tr.sort-filter-row > th {
  padding: 0.5rem 0.20rem;
  background-color: #f8f9fa;
  border-top: none;
}

.sort-filter-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.sort-control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
}

.filter-control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

::ng-deep .sort-control .p-sortable-column-icon {
  font-size: 1rem;
}

::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  border: 1px solid #dee2e6;
  padding: 0.20rem;
  padding-left: 6px;
}

::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
  background-color: #f8f9fa;
}

/* Empty and loading states */
::ng-deep .p-datatable .p-datatable-emptymessage > td {
  padding: 2rem;
  text-align: center;
  color: #6c757d;
}

/* Loading overlay customization - position outside table, center-aligned */
::ng-deep .p-datatable .p-datatable-loading-overlay {
  background-color: transparent !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: auto !important;
  height: auto !important;
  min-height: auto !important;
  z-index: 9999 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 2rem !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

::ng-deep .p-datatable {
  position: relative !important;
  height: auto !important;
}

::ng-deep .p-datatable .p-datatable-wrapper {
  position: relative;
  min-height: 0 !important;
  height: auto !important;
}

/* Table height based on content only - no fixed heights */
::ng-deep .p-datatable.p-datatable-loading .p-datatable-wrapper {
  height: auto !important;
  min-height: 0 !important;
}

::ng-deep .p-datatable.p-datatable-loading .p-datatable-scrollable-body {
  overflow: visible !important;
}

::ng-deep .p-datatable.p-datatable-loading {
  min-height: 0 !important;
  height: auto !important;
  position: relative !important;
}

::ng-deep .p-datatable.p-datatable-loading + .table-wrapper,
::ng-deep .table-wrapper:has(.p-datatable-loading) {
  overflow: visible !important;
}

/* Center align the loading spinner - make it bigger and more visible */
::ng-deep .p-datatable .p-datatable-loading-icon {
  font-size: 4rem !important;
  color: #007bff !important;
  width: 4rem !important;
  height: 4rem !important;
  position: fixed;
}

.grey-color {
  color: #6c757d;
}

/* Responsive */
@media (max-width: 768px) {
  .table-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  
  .toolbar-left,
  .toolbar-right {
    justify-content: center;
  }
  
  .global-search .search-input {
    width: 100%;
  }
  
  .sort-filter-wrapper {
    gap: 0.5rem;
  }
  
  .export-button {
  background-color: #0094ff;
  color: white; /* for text contrast */
  }

  ::ng-deep .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.875rem;
    padding: 0.5rem;
  }
  
  .header-content-wrapper {
    gap: 0.35rem;
  }
}

/* ========== Filter Popup Alignment & Styling ========== */
/* Match existing p-table filter popup behavior */

::ng-deep .p-multiselect-panel {
  width: 225px !important;
  padding-bottom: 15px;
  top: 26px !important;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  left: -100px !important;
  border-top: none;
  box-shadow: 0 9px 13px 6px rgba(0,0,0,0.15);
}

::ng-deep .ui-multiselect .ui-multiselect-panel {
  width: 225px !important;
  padding-bottom: 15px;
  top: 26px !important;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  left: -100px !important;
  border-top: none;
  box-shadow: 0 9px 13px 6px rgba(0,0,0,0.15);
}

::ng-deep .p-multiselect-panel .p-multiselect-header {
  padding-bottom: 0;
  border: none;
}

::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item {
  height: auto !important;
  color: #444444;
  width: auto !important;
}

::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  background-color: transparent;
  color: #000000;
}

::ng-deep .p-multiselect-panel .p-multiselect-item span {
  vertical-align: text-top;
}

/* Close button on filter popup - Right aligned */
::ng-deep .p-multiselect-panel .p-multiselect-header .p-multiselect-close {
  position: absolute !important;
  top: 5px !important;
  right: 5px !important;
  left: auto !important;
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

::ng-deep .p-multiselect-panel .p-multiselect-header .p-multiselect-close:hover {
  color: #495057;
  border-color: transparent;
  background: #e9ecef;
}

::ng-deep .p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}

/* Checkbox styling in filter dropdown */
::ng-deep .sfcDropDown .p-checkbox .p-checkbox-box .p-checkbox-icon {
  display: inline-block;
}

/* Multiselect trigger icon */
::ng-deep body .p-multiselect {
  background: none !important;
  border: none !important;  
  width: 17px !important;
}

::ng-deep body .p-multiselect .p-multiselect-trigger {
  background: none !important;
  width: auto !important;
  font-size: 21px !important;
  left: 0 !important;
}

::ng-deep body .p-multiselect .p-multiselect-trigger .p-multiselect-trigger-icon {
  font-size: 20px !important;
  color: #999999 !important;
}

/* Button Styles */
.buttonsHeight {
  height: 30px;
}

.delete-button {
  opacity: 0.5;
}

.export-button {
  background-color: #0094ff;
  color: white;
  margin-left: 0;
  border-radius: 4px;
}

.column-settings-button {
  margin-left: 0;
}

/* Button Styles */
::ng-deep .buttonsHeight .p-button {
  height: 30px !important;
  padding: 0 1rem !important;
}

::ng-deep .delete-button .p-button {
  opacity: 0.5;
}

::ng-deep .export-button .p-button {
  background-color: #0094ff !important;
  color: white !important;
  margin-left: 0;
  border-color: #0094ff !important;
}

::ng-deep .column-settings-button .p-button {
  margin-left: 0;
}

/* Button height for all buttons */
:host ::ng-deep .p-button.buttonsHeight {
  height: 30px !important;
  min-height: 30px !important;
}

:host ::ng-deep .p-button.delete-button {
  opacity: 0.5;
  height: 30px !important;
}

:host ::ng-deep .p-button.export-button {
  background-color: #0094ff !important;
  color: white !important;
  border-color: #0094ff !important;
  margin-left: 0;
  height: 30px !important;
}

:host ::ng-deep .p-button.column-settings-button {
  margin-left: 0;
  height: 30px !important;
}

:host ::ng-deep .p-table,
:host ::ng-deep .p-table > .p-datatable-table,
:host ::ng-deep .p-table th,
:host ::ng-deep .p-table td,
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  border: none !important;
  box-shadow: none !important;
}

/* Make all checkboxes in the dynamic table smaller */
.dynamic-select-checkbox {
  width: 20px;
  height: 20px;
  min-width: 20px;
  clip: auto !important;
  clip-path: none !important;
  position: static !important;
  left: auto !important;
  top: auto !important;
  margin: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  accent-color: #297dfd;
  background: #fff !important;
  cursor: pointer;
}

::ng-deep .p-multiselect-panel .p-multiselect-items {
  padding: 0.5rem 0;
  margin-left: 0px;
}

/* Remove background color from the filter option row */
::ng-deep .p-multiselect-items .p-multiselect-item {
  background: transparent !important;
}

.closeBtnDynamic{
  padding: 0 !important;
  min-width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}

::ng-deep .p-multiselect-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.filter-header-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
  white-space: nowrap;
}

.clearBtnDynamic{
    padding: 0 !important;
    height: auto;
    margin: 0 !important;
}

.okBtn {
  padding: 0 !important;
  height: auto;
  margin: 0 !important;
}

.filterLbl {
  padding-left: 10px !important;
  margin: 0;
  font-size: 16px;
  white-space: nowrap;
}

::ng-deep .selectAllWrap {
  display: flex;
  align-items: center;
  gap: 8px;
  clear: both;
  width: 100%;
  padding-top: 8px;
  position: relative;
  z-index: 3;
  pointer-events: auto !important;
}

.multiselect-select-checkbox {
  width: 18px;
  height: 18px;
  margin-left: 14px;
}

.selectAllLbl {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 20px;
  cursor: pointer;
}

::ng-deep .dynamic-filter-panel {
  width: 360px !important;
  max-width: 360px !important;
}

::ng-deep .dynamic-filter-panel .p-multiselect-items-wrapper {
  max-width: 100%;
}

.filter-option-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep .selectAllWrap .multiselect-select-checkbox + .selectAllLbl {
  position: static !important;
  padding-left: 0 !important;
}

::ng-deep .selectAllWrap .multiselect-select-checkbox + .selectAllLbl::before,
::ng-deep .selectAllWrap .multiselect-select-checkbox + .selectAllLbl::after {
  content: none !important;
  display: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/shared/dynamic-table/dynamic-table.component.css"],"names":[],"mappings":"AAAA;;;;EAIE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA,6CAA6C;AAC7C;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;;CAIC;AACD,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;EACA,yBAAyB;EACzB,YAAY,EAAE,sBAAsB;EACpC;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,2DAA2D;AAC3D,iDAAiD;;AAEjD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,8DAA8D;EAC9D,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;;;;EAME,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B","sourcesContent":[":host ::ng-deep ol,\r\n:host ::ng-deep ul,\r\n::ng-deep ol,\r\n::ng-deep ul {\r\n  padding-left: 0px !important;\r\n  margin-left: 0 !important;\r\n}\r\nol, ul {\r\n  padding-left: 0px !important;\r\n  margin-left: 0 !important;\r\n}\r\n/* ========== Container & Layout ========== */\r\n.dynamic-table-container {\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  overflow: visible;\r\n  position: relative;\r\n}\r\n\r\n.dynamic-table {\r\n   margin: 10px !important;\r\n}\r\n\r\n.table-toolbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  padding: 0.5rem 0;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.toolbar-left,\r\n.toolbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  position: relative;\r\n}\r\n\r\n/* Remove gap from button container */\r\n.d-flex.align-items-center.mb-1 {\r\n  gap: 0 !important;\r\n}\r\n\r\n.global-search {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.global-search .pi-search {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 60%;\r\n  transform: translateY(-60%);\r\n  z-index: 1;\r\n  pointer-events: none;\r\n}\r\n\r\n.global-search .search-input {\r\n  padding-left: 35px;\r\n  padding-right: 30px;\r\n  min-width: 200px;\r\n}\r\n\r\n.global-search .clear-search {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  color: #999;\r\n  z-index: 2;\r\n}\r\n\r\n.global-search .clear-search:hover {\r\n  color: #333;\r\n}\r\n\r\n.table-wrapper {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  overflow-y: visible;\r\n  margin: 15px 0;\r\n  margin-bottom: 60px;\r\n  position: relative;\r\n}\r\n\r\n.exportExcelBtn {\r\n  margin-left: 0;\r\n}\r\n\r\n/* Column Settings Button */\r\n.column-settings-button {\r\n  margin-left: 0;\r\n}\r\n\r\n/* Column Settings Panel */\r\n.column-settings-panel {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 100%;\r\n  margin-top: 0.5rem;\r\n  background: white;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\r\n  z-index: 1000;\r\n  min-width: 400px;\r\n  max-width: 500px;\r\n}\r\n\r\n.column-settings-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem;\r\n  border-bottom: 1px solid #dee2e6;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.column-settings-header h5 {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.column-settings-header .close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #6c757d;\r\n  font-size: 1.2rem;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s, color 0.2s;\r\n}\r\n\r\n.column-settings-header .close-btn:hover {\r\n  background-color: #e9ecef;\r\n  color: #333;\r\n}\r\n\r\n.column-settings-body {\r\n  padding: 1rem;\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.settings-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.settings-table thead tr {\r\n  background-color: #f8f9fa;\r\n  border-bottom: 2px solid #dee2e6;\r\n}\r\n\r\n.settings-table th {\r\n  padding: 0.75rem 0.5rem;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.settings-table tbody tr {\r\n  border-bottom: 1px solid #dee2e6;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.settings-table tbody tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.settings-table tbody tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.settings-table td {\r\n  padding: 0.75rem 0.5rem;\r\n  color: #333;\r\n}\r\n\r\n.settings-table .checkbox-cell {\r\n  text-align: center;\r\n  width: 100px;\r\n}\r\n\r\n.settings-table .disabled-text {\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Ensure pagination stays at bottom and center-aligned */\r\n::ng-deep .p-datatable .p-paginator {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.75rem;\r\n  border-top: 1px solid #dee2e6;\r\n  overflow: visible !important;\r\n}\r\n\r\n/* Make pagination dropdown smaller */\r\n::ng-deep .p-paginator .p-paginator-rpp-options {\r\n  width: auto !important;\r\n  min-width: 45px !important;\r\n  max-width: 55px !important;\r\n  height: 28px !important;\r\n  font-size: 0.875rem !important;\r\n  margin-left: 0 !important;\r\n  padding-left: 0 !important;\r\n}\r\n\r\n::ng-deep .p-paginator .p-dropdown {\r\n  height: 28px !important;\r\n  min-height: 28px !important;\r\n  margin-left: 0 !important;\r\n  width: 55px !important;\r\n}\r\n\r\n::ng-deep .p-paginator .p-dropdown .p-dropdown-trigger {\r\n  width: 1.5rem !important;\r\n}\r\n\r\n::ng-deep .p-paginator .p-dropdown .p-dropdown-label {\r\n  padding: 0.25rem 0.25rem !important;\r\n  padding-left: 0.25rem !important;\r\n  font-size: 0.875rem !important;\r\n}\r\n\r\n/* Ensure pagination dropdown panel is fully visible */\r\n::ng-deep .p-paginator .p-dropdown-panel {\r\n  z-index: 1100 !important;\r\n  margin-top: 2px !important;\r\n}\r\n\r\n::ng-deep .p-paginator .p-dropdown-panel .p-dropdown-items {\r\n  padding: 0 !important;\r\n}\r\n\r\n::ng-deep .p-paginator .p-dropdown-panel .p-dropdown-item {\r\n  padding: 0.5rem 0.75rem !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n::ng-deep .p-paginator .p-dropdown-panel .p-dropdown-items-wrapper {\r\n  padding: 0 !important;\r\n}\r\n\r\n::ng-deep .p-datatable-wrapper {\r\n  overflow-x: visible;\r\n  overflow-y: visible;\r\n}\r\n\r\n/* PrimeNG button disabled state */\r\n::ng-deep .p-button.p-disabled,\r\n::ng-deep .p-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Filter dropdown styles */\r\n.sfcDropDown {\r\n  margin-left: 0;\r\n}\r\n\r\n::ng-deep .sfcDropDown .p-multiselect {\r\n  border: none;\r\n  background: transparent;\r\n}\r\n\r\n::ng-deep .sfcDropDown .p-multiselect-trigger {\r\n  color: #007bff;\r\n}\r\n\r\n::ng-deep .filter-control .p-multiselect {\r\n  min-height: auto;\r\n}\r\n\r\n.filter-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.filterLbl {\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.filter-header .okBtn,\r\n.filter-header .clearBtn {\r\n  padding: 0 8px;\r\n  font-size: 14px;\r\n  text-decoration: none !important;\r\n  color: #007bff;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.filter-header .okBtn:hover,\r\n.filter-header .clearBtn:hover {\r\n  text-decoration: underline !important;\r\n}\r\n\r\n/* Table styles */\r\n::ng-deep .p-datatable .p-datatable-thead > tr > th {\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.5rem 0.4rem;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  vertical-align: middle;\r\n}\r\n/*\r\n::ng-deep .p-datatable .p-datatable-tbody > tr > td.audit-updated-cell {\r\n  background-color: #fff59d !important;\r\n}\r\n*/\r\n/* Header Content Wrapper - Inline alignment */\r\n.header-content-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: nowrap;\r\n  flex-direction: row;\r\n  min-width: 0;\r\n}\r\n\r\n.header-text {\r\n  flex: 1 1 0;\r\n  font-weight: 600;\r\n  margin-right: 0.15rem;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.header-sort-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 0 0 auto;\r\n  margin-left: 0.15rem;\r\n  z-index: 1;\r\n}\r\n\r\n.header-filter-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 0 0 auto;\r\n  margin-left: 0.15rem;\r\n  z-index: 1;\r\n}\r\n\r\n.title{\r\n  margin-bottom: 0;\r\n  margin-left: -15px;\r\n}\r\n\r\n::ng-deep .header-sort-icon .p-sortable-column-icon {\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Sort and Filter Row Styling - DEPRECATED (keeping for backward compatibility) */\r\n::ng-deep .p-datatable .p-datatable-thead > tr.sort-filter-row > th {\r\n  padding: 0.5rem 0.20rem;\r\n  background-color: #f8f9fa;\r\n  border-top: none;\r\n}\r\n\r\n.sort-filter-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 1rem;\r\n}\r\n\r\n.sort-control {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 20px;\r\n}\r\n\r\n.filter-control {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n::ng-deep .sort-control .p-sortable-column-icon {\r\n  font-size: 1rem;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.20rem;\r\n  padding-left: 6px;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-tbody > tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n/* Empty and loading states */\r\n::ng-deep .p-datatable .p-datatable-emptymessage > td {\r\n  padding: 2rem;\r\n  text-align: center;\r\n  color: #6c757d;\r\n}\r\n\r\n/* Loading overlay customization - position outside table, center-aligned */\r\n::ng-deep .p-datatable .p-datatable-loading-overlay {\r\n  background-color: transparent !important;\r\n  position: fixed !important;\r\n  top: 50% !important;\r\n  left: 50% !important;\r\n  transform: translate(-50%, -50%) !important;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  min-height: auto !important;\r\n  z-index: 9999 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  padding: 2rem !important;\r\n  border-radius: 8px !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep .p-datatable {\r\n  position: relative !important;\r\n  height: auto !important;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-wrapper {\r\n  position: relative;\r\n  min-height: 0 !important;\r\n  height: auto !important;\r\n}\r\n\r\n/* Table height based on content only - no fixed heights */\r\n::ng-deep .p-datatable.p-datatable-loading .p-datatable-wrapper {\r\n  height: auto !important;\r\n  min-height: 0 !important;\r\n}\r\n\r\n::ng-deep .p-datatable.p-datatable-loading .p-datatable-scrollable-body {\r\n  overflow: visible !important;\r\n}\r\n\r\n::ng-deep .p-datatable.p-datatable-loading {\r\n  min-height: 0 !important;\r\n  height: auto !important;\r\n  position: relative !important;\r\n}\r\n\r\n::ng-deep .p-datatable.p-datatable-loading + .table-wrapper,\r\n::ng-deep .table-wrapper:has(.p-datatable-loading) {\r\n  overflow: visible !important;\r\n}\r\n\r\n/* Center align the loading spinner - make it bigger and more visible */\r\n::ng-deep .p-datatable .p-datatable-loading-icon {\r\n  font-size: 4rem !important;\r\n  color: #007bff !important;\r\n  width: 4rem !important;\r\n  height: 4rem !important;\r\n  position: fixed;\r\n}\r\n\r\n.grey-color {\r\n  color: #6c757d;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .table-toolbar {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .toolbar-left,\r\n  .toolbar-right {\r\n    justify-content: center;\r\n  }\r\n  \r\n  .global-search .search-input {\r\n    width: 100%;\r\n  }\r\n  \r\n  .sort-filter-wrapper {\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .export-button {\r\n  background-color: #0094ff;\r\n  color: white; /* for text contrast */\r\n  }\r\n\r\n  ::ng-deep .p-datatable .p-datatable-thead > tr > th {\r\n    font-size: 0.875rem;\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .header-content-wrapper {\r\n    gap: 0.35rem;\r\n  }\r\n}\r\n\r\n/* ========== Filter Popup Alignment & Styling ========== */\r\n/* Match existing p-table filter popup behavior */\r\n\r\n::ng-deep .p-multiselect-panel {\r\n  width: 225px !important;\r\n  padding-bottom: 15px;\r\n  top: 26px !important;\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n  left: -100px !important;\r\n  border-top: none;\r\n  box-shadow: 0 9px 13px 6px rgba(0,0,0,0.15);\r\n}\r\n\r\n::ng-deep .ui-multiselect .ui-multiselect-panel {\r\n  width: 225px !important;\r\n  padding-bottom: 15px;\r\n  top: 26px !important;\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n  left: -100px !important;\r\n  border-top: none;\r\n  box-shadow: 0 9px 13px 6px rgba(0,0,0,0.15);\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-header {\r\n  padding-bottom: 0;\r\n  border: none;\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item {\r\n  height: auto !important;\r\n  color: #444444;\r\n  width: auto !important;\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\r\n  background-color: transparent;\r\n  color: #000000;\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-item span {\r\n  vertical-align: text-top;\r\n}\r\n\r\n/* Close button on filter popup - Right aligned */\r\n::ng-deep .p-multiselect-panel .p-multiselect-header .p-multiselect-close {\r\n  position: absolute !important;\r\n  top: 5px !important;\r\n  right: 5px !important;\r\n  left: auto !important;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  color: #6c757d;\r\n  border: 0 none;\r\n  background: transparent;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: auto;\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-header .p-multiselect-close:hover {\r\n  color: #495057;\r\n  border-color: transparent;\r\n  background: #e9ecef;\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus {\r\n  outline: 0 none;\r\n  outline-offset: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\r\n}\r\n\r\n/* Checkbox styling in filter dropdown */\r\n::ng-deep .sfcDropDown .p-checkbox .p-checkbox-box .p-checkbox-icon {\r\n  display: inline-block;\r\n}\r\n\r\n/* Multiselect trigger icon */\r\n::ng-deep body .p-multiselect {\r\n  background: none !important;\r\n  border: none !important;  \r\n  width: 17px !important;\r\n}\r\n\r\n::ng-deep body .p-multiselect .p-multiselect-trigger {\r\n  background: none !important;\r\n  width: auto !important;\r\n  font-size: 21px !important;\r\n  left: 0 !important;\r\n}\r\n\r\n::ng-deep body .p-multiselect .p-multiselect-trigger .p-multiselect-trigger-icon {\r\n  font-size: 20px !important;\r\n  color: #999999 !important;\r\n}\r\n\r\n/* Button Styles */\r\n.buttonsHeight {\r\n  height: 30px;\r\n}\r\n\r\n.delete-button {\r\n  opacity: 0.5;\r\n}\r\n\r\n.export-button {\r\n  background-color: #0094ff;\r\n  color: white;\r\n  margin-left: 0;\r\n  border-radius: 4px;\r\n}\r\n\r\n.column-settings-button {\r\n  margin-left: 0;\r\n}\r\n\r\n/* Button Styles */\r\n::ng-deep .buttonsHeight .p-button {\r\n  height: 30px !important;\r\n  padding: 0 1rem !important;\r\n}\r\n\r\n::ng-deep .delete-button .p-button {\r\n  opacity: 0.5;\r\n}\r\n\r\n::ng-deep .export-button .p-button {\r\n  background-color: #0094ff !important;\r\n  color: white !important;\r\n  margin-left: 0;\r\n  border-color: #0094ff !important;\r\n}\r\n\r\n::ng-deep .column-settings-button .p-button {\r\n  margin-left: 0;\r\n}\r\n\r\n/* Button height for all buttons */\r\n:host ::ng-deep .p-button.buttonsHeight {\r\n  height: 30px !important;\r\n  min-height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .p-button.delete-button {\r\n  opacity: 0.5;\r\n  height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .p-button.export-button {\r\n  background-color: #0094ff !important;\r\n  color: white !important;\r\n  border-color: #0094ff !important;\r\n  margin-left: 0;\r\n  height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .p-button.column-settings-button {\r\n  margin-left: 0;\r\n  height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .p-table,\r\n:host ::ng-deep .p-table > .p-datatable-table,\r\n:host ::ng-deep .p-table th,\r\n:host ::ng-deep .p-table td,\r\n:host ::ng-deep .p-datatable .p-datatable-thead > tr > th,\r\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n/* Make all checkboxes in the dynamic table smaller */\r\n.dynamic-select-checkbox {\r\n  width: 20px;\r\n  height: 20px;\r\n  min-width: 20px;\r\n  clip: auto !important;\r\n  clip-path: none !important;\r\n  position: static !important;\r\n  left: auto !important;\r\n  top: auto !important;\r\n  margin: 0 !important;\r\n  opacity: 1 !important;\r\n  visibility: visible !important;\r\n  appearance: auto !important;\r\n  -webkit-appearance: checkbox !important;\r\n  accent-color: #297dfd;\r\n  background: #fff !important;\r\n  cursor: pointer;\r\n}\r\n\r\n::ng-deep .p-multiselect-panel .p-multiselect-items {\r\n  padding: 0.5rem 0;\r\n  margin-left: 0px;\r\n}\r\n\r\n/* Remove background color from the filter option row */\r\n::ng-deep .p-multiselect-items .p-multiselect-item {\r\n  background: transparent !important;\r\n}\r\n\r\n.closeBtnDynamic{\r\n  padding: 0 !important;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 !important;\r\n}\r\n\r\n::ng-deep .p-multiselect-header-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  width: 100%;\r\n}\r\n\r\n.filter-header-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-left: auto;\r\n  white-space: nowrap;\r\n}\r\n\r\n.clearBtnDynamic{\r\n    padding: 0 !important;\r\n    height: auto;\r\n    margin: 0 !important;\r\n}\r\n\r\n.okBtn {\r\n  padding: 0 !important;\r\n  height: auto;\r\n  margin: 0 !important;\r\n}\r\n\r\n.filterLbl {\r\n  padding-left: 10px !important;\r\n  margin: 0;\r\n  font-size: 16px;\r\n  white-space: nowrap;\r\n}\r\n\r\n::ng-deep .selectAllWrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  clear: both;\r\n  width: 100%;\r\n  padding-top: 8px;\r\n  position: relative;\r\n  z-index: 3;\r\n  pointer-events: auto !important;\r\n}\r\n\r\n.multiselect-select-checkbox {\r\n  width: 18px;\r\n  height: 18px;\r\n  margin-left: 14px;\r\n}\r\n\r\n.selectAllLbl {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  line-height: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n::ng-deep .dynamic-filter-panel {\r\n  width: 360px !important;\r\n  max-width: 360px !important;\r\n}\r\n\r\n::ng-deep .dynamic-filter-panel .p-multiselect-items-wrapper {\r\n  max-width: 100%;\r\n}\r\n\r\n.filter-option-text {\r\n  display: block;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n::ng-deep .selectAllWrap .multiselect-select-checkbox + .selectAllLbl {\r\n  position: static !important;\r\n  padding-left: 0 !important;\r\n}\r\n\r\n::ng-deep .selectAllWrap .multiselect-select-checkbox + .selectAllLbl::before,\r\n::ng-deep .selectAllWrap .multiselect-select-checkbox + .selectAllLbl::after {\r\n  content: none !important;\r\n  display: none !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
